import haklaiThirdPartyService from "../../../services/haklaiThirdPartyService";

export const convertHaklaiDollarCurrency = (amount, date) => (
  haklaiThirdPartyService.convertDollarCurrency(amount, date)
);
